import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { DecisionMaker } from '../types';

import {
	DecisionMakerSearch,
	type DecisionMakerSearchQuery,
	type DecisionMakerSearchQueryVariables,
} from './searchDecisionMakers.graphql';

type Params = {
	searchQuery: string;
	countryCode: string;
};

export async function searchDecisionMakers(
	{ searchQuery, countryCode }: Params,
	{ gql: { fetch } }: UtilityContext,
): Promise<readonly DecisionMaker[]> {
	if (searchQuery.trim() === '') return [];

	const { data } = await fetch<DecisionMakerSearchQuery, DecisionMakerSearchQueryVariables>({
		query: DecisionMakerSearch,
		variables: { searchQuery, countryCode: countryCode || null },
		rejectOnError: true,
	});

	const response = data.decisionMakersByCriteria;
	if (response?.__typename !== 'SearchDecisionMakersResult') {
		throw new Error('Decision maker search failed');
	}

	return [
		...response.items.map((item) => ({
			id: item.id,
			displayName: item.displayName,
			summary: item.summary,
			isPerson: item.isPerson,
			isConfirmed: item.isConfirmed,
			isVerified: item.isVerified,
			photo: item.photo ? { id: item.photo.id, userSmall: { url: item.photo.userSmall.url } } : null,
		})),
		// Adding this unconfirmed dummy DM to trigger the "Add DM" functionality
		{
			id: '0',
			displayName: searchQuery.trim(),
			isPerson: null,
			isConfirmed: false,
			isVerified: false,
			photo: null,
			summary: '',
		},
	];
}
